import { createContext } from 'react'
//Alert Messages
const alertContext = createContext()

export default alertContext
